import React from "react";
import moneyIcon from "../../static/money.svg";
import { styles } from "./styles";
import GazableButton from "components/GazableButton/GazableButton";
import gazableButtons from "constants/gazableButtons";
import mageTower from "../../static/MageTower/TowerWeapon.png";
import archeryTower from "../../static/ArcherTower/ArcheryTower.png";
import { setCanvasSize } from "helpers/mathFunctions";
import { useCanvasStore } from "store/CanvasStore";

const TowerPlacementOverlay: React.FC = () => {
  const { showBuild, startTowerBuild, showHideTowerBuild, setTowerType } =
    useCanvasStore();
  const { height, width, scale } = setCanvasSize();
  const moneyIconSize = 25 * scale;

  if (!showBuild) {
    return <></>;
  }

  const handleOnClick = () => {
    showHideTowerBuild();
    startTowerBuild();
  };

  return (
    <div
      style={{
        ...styles.gazableTowerControls,
        height,
        // width - GameControls Witdh * Scale - GameControlsPadding
        width: width - 350 * scale - 80,
      }}
    >
      <h1 style={styles.gazableTowerControlsHeader}>Pick a Tower Type</h1>
      <div style={styles.gazableTowerControlsType}>
        {/* Archery Tower */}
        <div style={styles.gazableTowerControlsTower}>
          <GazableButton
            type={gazableButtons.squareButtonTwo}
            content={""}
            onClick={() => {
              handleOnClick();
              setTowerType("archer");
            }}
          >
            <img src={archeryTower} alt="Archer Tower" />
          </GazableButton>
          <span> Archery Tower </span>
          <div style={styles.gazableTowerControlsCost}>
            <img
              src={moneyIcon}
              alt="Money"
              width={moneyIconSize}
              height={moneyIconSize}
            />
            <span>50</span>
          </div>
          <span>D: 20</span>
          <span>R: 175</span>
        </div>

        {/* Mage Tower */}
        <div style={styles.gazableTowerControlsTower}>
          <GazableButton
            type={gazableButtons.squareButtonTwo}
            content={""}
            onClick={() => {
              handleOnClick();
              setTowerType("mage");
            }}
          >
            <img src={mageTower} alt="Mage Tower" />
          </GazableButton>
          <span> Mage Tower </span>
          <div style={styles.gazableTowerControlsCost}>
            <img src={moneyIcon} alt="Money" width="25" height="25" />
            <span>80</span>
          </div>
          <span>D: 40</span>
          <span>R: 125</span>
        </div>
      </div>
    </div>
  );
};

export default TowerPlacementOverlay;
